import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// A successful load means whatever chunk-load-triggered reload happened (if
// any) worked — clear the guard so a future deploy's stale-chunk error can
// trigger the auto-reload again in this same tab.
sessionStorage.removeItem('chunk-reload-attempted');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
